import React, {useEffect, useState} from 'react';

import springboard from 'springboard';

import {useSearchParams} from 'react-router-dom';
import {getSiteUrl} from '@/store/utils/get_site_url';


import '@/modules/music_sniper/components/modals/modals_provider';
import '@/modules/mantine/mantine_module';


import './styles.css';

// import {CustomDropZone} from '@/components/custom_drop_zone';

// import {Button} from '@mantine/core'
import {WithCallOptions, useActions, useSelectorWithRefresh, useSelectors} from '../../store/kysely_module';
import {FileViewPage} from './pages/file_view_page';
import {useEnsureCurrentWorkspaceId} from '../../store/modules/workspaces_module';
import {FileTable} from './components/file_table';
import {useParams} from 'react-router';
import {WorkspaceSelectionPage} from './pages/workspace_selection_page';
import {ProjectSelectionPage} from './pages/project_selection_page';
import {ProjectViewPage} from './pages/project_view_page';

import './components/application_shell/application_shell_module';
import {registerBreadcrumbs} from './components/application_shell/breadcrumbs/breadcrumbs';
import {QRCode} from '@/components/qrcode';
import {NewDashboard} from '@/components/new_dashboard/new_dashboard';
import {NewProjectViewPage} from '@/components/new_project_view_page/new_project_view_page';

declare module 'springboard/module_registry/module_registry' {
    interface AllModules {
        MusicSniper: MusicSniperModuleReturnValue;
    }
}

type MusicSniperModuleReturnValue = {

};

springboard.registerModule('MusicSniper', {}, async (moduleAPI): Promise<MusicSniperModuleReturnValue> => {
    moduleAPI.registerRoute('/workspaces', {}, () => {
        useEnsureCurrentWorkspaceId();

        const loginFlowModule = moduleAPI.getModule('LoginFlow');
        useEffect(() => {
            loginFlowModule.resetStoredInvite();
        }, []);

        return (
            <WorkspaceSelectionPage />
        );
    });

    moduleAPI.registerRoute('/dashboard', {}, () => {
        useEnsureCurrentWorkspaceId();

        const loginFlowModule = moduleAPI.getModule('LoginFlow');
        useEffect(() => {
            loginFlowModule.resetStoredInvite();
        }, []);

        return (
            <NewDashboard />
        );
    });

    moduleAPI.registerRoute('/workspaces/:workspaceId/projects', {}, () => {
        const workspaceId = useParams().workspaceId;
        if (!workspaceId) {
            return 'No workspace id in url';
        }

        return (
            <ProjectSelectionPage
                workspaceId={workspaceId}
            />
        );
    });

    registerBreadcrumbs('/workspaces/:workspaceId/projects', async (params) => {
        const workspaceId = params.workspaceId;
        if (!workspaceId) {
            return [];
        }

        const kyselyModule = moduleAPI.getModule('Kysely');

        const workspacesModule = moduleAPI.getModule('Workspaces');
        const knownWorkspaces = workspacesModule.knownWorkspacesState.getState();
        const matchingWorkspace = knownWorkspaces.find(w => w.workspace.id === params.workspaceId);
        const isLocalWorkspace = Boolean(matchingWorkspace && matchingWorkspace.type === 'local');
        const mode = isLocalWorkspace ? 'local' : 'remote';

        const workspace = await kyselyModule.selectors.getWorkspace({workspace_id: workspaceId}, {mode});

        if (!workspace) {
            return [];
        }

        return [
            {
                label: workspace.name,
                link: `/workspaces/${workspace.id}/projects`,
            },
        ];
    });

    moduleAPI.registerRoute('/workspaces/:workspaceId/projects/:projectId', {}, () => {
        const params = useParams();
        const projectId = params.projectId;
        if (!projectId) {
            return 'No project id in url';
        }

        const workspaceId = params.workspaceId;
        if (!workspaceId) {
            return 'No workspace id in url';
        }

        return (
            <NewProjectViewPage
                key={projectId}
                projectId={projectId}
                workspaceId={workspaceId}
            />
        );

        // return (
        //     <ProjectViewPage
        //         key={projectId} // TODO: this causes some jumpiness on changing project from sidebar. it's necessary to reload data atm though
        //         project_id={projectId}
        //         workspace_id={workspaceId}
        //     />
        // );
    });

    moduleAPI.registerRoute('/qrcode_invite', {hideApplicationShell: true}, () => {
        const siteUrl = getSiteUrl();
        const [searchParams] = useSearchParams();
        const url = searchParams.get('url') || siteUrl;

        return (
            <div style={{textAlign: 'center'}}>
                <h2>SongDrive</h2>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <QRCode
                        url={url}
                        style={{height: '200px'}}
                    />
                </div>
                <p style={{marginTop: '20px'}}>
                    <a href={url}>
                        {url}
                    </a>
                </p>
            </div >
        )
    });

    registerBreadcrumbs('/workspaces/:workspaceId/projects/:projectId', async (params) => {
        const projectId = params.projectId;
        if (!projectId) {
            return [];
        }

        const workspaceId = params.workspaceId;
        if (!workspaceId) {
            return [];
        }

        const kyselyModule = moduleAPI.getModule('Kysely');

        const workspacesModule = moduleAPI.getModule('Workspaces');
        const knownWorkspaces = workspacesModule.knownWorkspacesState.getState();
        const matchingWorkspace = knownWorkspaces.find(w => w.workspace.id === params.workspaceId);
        const isLocalWorkspace = Boolean(matchingWorkspace && matchingWorkspace.type === 'local');
        const mode = isLocalWorkspace ? 'local' : 'remote';

        const projectInfo = await kyselyModule.selectors.getProjectWithAncestors(
            {project_id: projectId},
            {mode},
        );
        if (!projectInfo) {
            return [];
        }

        const parentProjects = [...projectInfo.parent_projects].sort((a, b) => (a.project_ancestry?.split(',').length || 0) - (b.project_ancestry?.split(',').length || 0));

        return [
            {
                label: projectInfo.workspace.name,
                link: `/workspaces/${projectInfo.workspace.id}/projects`,
            },
            ...parentProjects.map(parentProject => ({
                label: parentProject.name,
                link: `/workspaces/${parentProject.workspace_id}/projects/${parentProject.id}`,
            })),
            {
                label: projectInfo.name,
                link: `/workspaces/${projectInfo.workspace_id}/projects/${projectInfo.id}`,
                avoidLink: true,
            },
        ];
    });

    registerBreadcrumbs('/workspaces/:workspaceId/files/:fileId', async (params) => {
        const fileId = params.fileId;
        if (!fileId) {
            return [];
        }

        const workspaceId = params.workspaceId;
        if (!workspaceId) {
            return [];
        }

        const kyselyModule = moduleAPI.getModule('Kysely');

        const workspacesModule = moduleAPI.getModule('Workspaces');
        const knownWorkspaces = workspacesModule.knownWorkspacesState.getState();
        const matchingWorkspace = knownWorkspaces.find(w => w.workspace.id === params.workspaceId);
        const isLocalWorkspace = Boolean(matchingWorkspace && matchingWorkspace.type === 'local');
        const mode = isLocalWorkspace ? 'local' : 'remote';

        const fileAndProjectInfo = await kyselyModule.selectors.getBreadcrumbInfoForFile(
            {file_id: fileId},
            {mode},
        );
        if (!fileAndProjectInfo) {
            return [];
        }

        return [
            {
                label: fileAndProjectInfo.workspace.name,
                link: `/workspaces/${fileAndProjectInfo.workspace.id}/projects`,
            },
            ...fileAndProjectInfo.parent_projects.map(parentProject => ({
                label: parentProject.name,
                link: `/workspaces/${parentProject.workspace_id}/projects/${parentProject.id}`,
            })),
            {
                label: fileAndProjectInfo.project.name,
                link: `/workspaces/${fileAndProjectInfo.workspace.id}/projects/${fileAndProjectInfo.project.id}`,
            },
        ]
    });

    moduleAPI.registerRoute('/workspaces/:workspaceId/files/:fileId', {}, ({navigate}) => {
        const params = useParams();
        const fileId = params.fileId;
        if (!fileId) {
            return 'No file id in url';
        }

        const workspaceId = params.workspaceId;
        if (!workspaceId) {
            return 'No workspace id in url';
        }

        return (
            <FileViewPage
                file_id={fileId}
                workspace_id={workspaceId}
            />
        );
    });

    return {
    };
});
